module.exports = __webpack_public_path__ + "static/media/background-nature.2786b604.jpg";